import { type MeetingAvailabilityResponse } from '@/pages/api/hubspot/get-meeting-availability';
import { useQuery } from '@tanstack/react-query';

export const GET_MEETING_AVAILABILITY = '/api/hubspot/get-meeting-availability';

async function fetchMeetingAvailability(
  slug: string,
  monthOffset: number,
  timezone: string
): Promise<MeetingAvailabilityResponse> {
  const params = new URLSearchParams({
    slug,
    monthOffset: String(monthOffset),
    timezone,
  });

  const response = await fetch(`${GET_MEETING_AVAILABILITY}?${params}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch availability: ${response.status}`);
  }

  return (await response.json()) as MeetingAvailabilityResponse;
}

export function useQueryMeetingAvailability(
  slug: string | null,
  monthOffset: number,
  timezone: string
) {
  return useQuery({
    enabled: !!slug,
    queryKey: [GET_MEETING_AVAILABILITY, slug, monthOffset, timezone],
    queryFn: () => (slug ? fetchMeetingAvailability(slug, monthOffset, timezone) : null),
    staleTime: 2 * 60 * 1000, // Cache for 2 minutes
  });
}
